import React, { useEffect, useState } from "react";
import { Button, Checkbox, DatePicker, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EditOutlined, EyeFilled } from "@ant-design/icons";
import "../../../css/common.css";
import { post } from "../../../../services/services.js";
import { ApiURL, generatesulphurfcr } from "../../../../services/apiConstants.js";
import VoyageDetails from "../../../../components/VoyageDetails.js";
import useVoyageList from "../../../../hooks/useVoyageList.js";
import useUserData from "../../../../hooks/useUserData.js";
import dayjs from "dayjs";
import { dateRanges } from "../../../../Data/data.js";
import { DOWNLOADPDF } from "../../../../utils/downloadPdf.js";
import RequestFormModal_bunker_fcr from "../../../../components/RequestModel_bunker_fcr.js";

const { RangePicker } = DatePicker;

const ListFuelChangeover = () => {
  const navigate = useNavigate();
  const user = useUserData();
  const { voyageList } = useVoyageList();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [voyage_ids, set_voyage_id] = useState("");
  const [voyage_status, set_voyage_status] = useState(true);
  const [isModalVisible, setModalVisible] = useState(false);
  const [record_id, set_record_id] = useState("");
  const [dates, setDates] = useState([dayjs().subtract(2, "day"), dayjs()]);
  const [startDate, endDate] = dates?.map((d) => d.format("YYYY-MM-DD"))||[];

  useEffect(() => {
    const staffData = JSON.parse(localStorage.getItem("staff_dashboard") || "{}");
    set_staff_dashboard(staffData);
  }, []);

  useEffect(() => {
    if (voyageList?.length > 0) {
      const runningVoyage = voyageList.find((voyage) => voyage.voyage_status === true);
      set_voyage_status(runningVoyage?.voyage_status || false);
      if (runningVoyage) {
        set_voyage_id(runningVoyage.id);
        if (runningVoyage?.id) LIST_FUEL_CHARGEOVER_API(runningVoyage.id);
      }
    }
  }, [voyageList]);

  const LIST_FUEL_CHARGEOVER_API = (voyage_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", voyage_id);
      post(ApiURL.list_bunker_fuel_chargerover_st_fcr, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const reversedData = res.records?.map((item) => ({
            ...item,
            key: item.record_id.toString(),
          }));
          setFilteredData(reversedData);
        }
        set_page_loader(false);
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "record_id",
      align: "center",
      key: "record_id",
      sorter: (a, b) => a.record_id - b.record_id,
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.record_id}
        </span>
      ),
    },
    {
      title: "Date and time of completion of change-over to low sulphur fuel oil",
      dataIndex: "date_and_time_completion",
      align: "center",
      key: "date_and_time_completion",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.date_and_time_completion}
        </span>
      ),
    },
    {
      title: "Ship Position",
      dataIndex: "ship_position",
      align: "center",
      key: "ship_position",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.ship_position}
        </span>
      ),
    },
    {
      title: "Low sulphur fuel oil quantities at completion of change over (Tank ID/m3)",
      dataIndex: "low_sulphur_quality_completion",
      align: "center",
      key: "low_sulphur_quality_completion",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.low_sulphur_quality_completion}
        </span>
      ),
    },
    {
      title: "Date and time of entry into ECA-Sox",
      dataIndex: "date_and_time_entry_eca",
      align: "center",
      key: "date_and_time_entry_eca",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.date_and_time_entry_eca}
        </span>
      ),
    },
    {
      title: "Date and time of exit from ECA-Sox",
      dataIndex: "date_and_time_exit_eca",
      align: "center",
      key: "date_and_time_exit_eca",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.date_and_time_entry_eca}
        </span>
      ),
    },
    {
      title: (
        <Tooltip title={"No selections"}>
          <div style={{ textAlign: "center" }}>
            <span>Confirmed by Chief Engineer</span>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={
                filteredData.length > 0 &&
                filteredData.every((item) => item.confirm_by_chiefEngneer)
              }
              indeterminate={
                filteredData.some((item) => item.confirm_by_chiefEngneer) &&
                !filteredData.every((item) => item.confirm_by_chiefEngneer)
              }
              disabled
            />
          </div>
        </Tooltip>
      ),
      dataIndex: "updated_at",
      align: "center",
      key: "chief_review",
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Checkbox checked={record.confirm_by_chiefEngneer} disabled />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
            }}
          >
            Confirmed by Chief Engineer
          </span>
        </div>
      ),
    },
    // {
    //   title: "Action",
    //   align: "center",
    //   key: "Action",
    //   render: (text, record) => {
    //     const isChifEngineer = user?.data?.designation === "Chief Engineer";
    //     const reviewed = record?.confirm_by_chiefEngneer;
    //     const handleEdit = () => {
    //       if (reviewed && isChifEngineer) {
    //         setModalVisible(!isModalVisible);
    //         set_record_id(record?.record_id);
    //       } else {
    //         navigate(`/edit-fuel-changeover/${btoa(record?.record_id)}`);
    //       }
    //     };
    //     const viewButton = (
    //       <Tooltip title="View">
    //         <Button
    //           type="primary"
    //           size="small"
    //           onClick={() => navigate(`/edit-fuel-changeover/${btoa(record?.record_id)}`)}
    //           icon={<EyeFilled />}
    //         />
    //       </Tooltip>
    //     );
    //     // Always show View button
    //     if (record?.soft_delete) {
    //       return viewButton;
    //     }
    //     if (!record?.soft_delete && isChifEngineer) {
    //       return (
    //         <>
    //           <Tooltip
    //             title={
    //               !voyage_status ? "Editing is disabled when voyage status is inactive." : "Edit"
    //             }
    //           >
    //             <span>
    //               <Button
    //                 disabled={!voyage_status}
    //                 type="primary"
    //                 size="small"
    //                 onClick={handleEdit}
    //                 icon={<EditOutlined />}
    //               />
    //             </span>
    //           </Tooltip>
    //         </>
    //       );
    //     }
    //     return viewButton;
    //   },
    // },
    {
  title: "Action",
  align: "center",
  key: "Action",
  render: (text, record) => {
    const isChifEngineer = user?.data?.designation === "Chief Engineer";
    const reviewed = record?.confirm_by_chiefEngneer;

    const handleEdit = () => {
      if (reviewed && isChifEngineer) {
        setModalVisible(!isModalVisible);
        set_record_id(record?.record_id);
      } else {
        navigate(`/edit-fuel-changeover/${btoa(record?.record_id)}`);
      }
    };

    const viewButton = (
  <Tooltip title="View">
    <Button
      size="small"
      icon={<EyeFilled />}
      onClick={() =>
        navigate(`/view-fuel-changeover/${btoa(record?.record_id)}`)
      }
      style={{
        backgroundColor: "#E11236",
        color: "#fff",
        borderColor: "#E11236",
      }}
    />
  </Tooltip>
);

    if (record?.soft_delete) {
      return viewButton;
    }

    if (!record?.soft_delete && isChifEngineer) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Tooltip
            title={
              !voyage_status
                ? "Editing is disabled when voyage status is inactive."
                : "Edit"
            }
          >
            <span>
              <Button
                disabled={!voyage_status}
                type="primary"
                size="small"
                onClick={handleEdit}
                icon={<EditOutlined />}
              />
            </span>
          </Tooltip>
          {viewButton}
        </div>
      );
    }

    return viewButton;
  },
}

  ];

  return (
    <>
      <VoyageDetails
        staff_dashboard={staff_dashboard?.voyage_details}
        buttonShow={true}
        disabled={!voyage_status}
        buttonProps={{
          text: "Add Logs",
          className: "save_btn",
          onClick: () => navigate("/add-fuel-changeover"),
          onPress: () => navigate("/audit-trail-fuel-changeover"),
        }}
      />
      <div className="row">
        <div className="col-3" style={{ marginBottom: "13px", marginLeft: "15px" }}>
          <label className="block-label">Select Voyage Id</label>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage_ids}
            onChange={(value) => {
              const selectedVoyage = voyageList.find((voyage) => voyage.id === value);
              if (selectedVoyage) {
                set_voyage_status(selectedVoyage.voyage_status);
              }
              set_voyage_id(value);
              LIST_FUEL_CHARGEOVER_API(value);
            }}
          >
            {voyageList?.map((voyage) => (
              <Select.Option key={voyage.id} value={voyage.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voyage.id}`}</span>
                  <span
                    style={{
                      color: voyage.voyage_status === true ? "#FFA500" : "#008000",
                      fontWeight: "550",
                      marginRight: "15px",
                    }}
                  >
                    {voyage.voyage_status === true ? "Running" : "Complete"}
                  </span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div style={{ marginRight: "15px" }}>
            <label className="block-label">Select Start Date & End Date</label>
            <RangePicker
              presets={dateRanges}
              value={dates}
              onChange={setDates}
              format="YYYY-MM-DD"
              style={{ width: 350 }}
              disabledDate={(current) => current && current > dayjs().endOf("day")}
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <Button
              type="primary"
              className="save_btn"
              style={{ color: "white", marginBottom: "13px" }}
              onClick={() => DOWNLOADPDF(generatesulphurfcr, voyage_ids, startDate, endDate)}
            >
              Download Pdf
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
      <RequestFormModal_bunker_fcr
        visible={isModalVisible}
        record_id={record_id}
        voyage_ids={voyage_ids}
        setModalVisible={setModalVisible}
        onCancel={() => {
          setModalVisible(!isModalVisible);
        }}
      />
    </>
  );
};

export default ListFuelChangeover;
